module.exports = __webpack_public_path__ + "img/NSIA-Assurance-Banque.81f0c21f.png";